import { createPinia } from 'pinia'

// 1. 创建 pinia 实例
const store = createPinia()

// 2. 导出 store 实例 (这是你需要的)
export { store }